import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import './header.css';

class Header extends Component {
  render() {
    return (
      <div className="header__content">
        <h1 className="header__banner">
          Hi, Kylie here.
        </h1>
        <div className="header__subtext">
          Software Developer • Melbourne, Australia
        </div>

        <div className="header__snsLinks">
          <a href="https://www.linkedin.com/in/kyliexie/" target="_blank">
            <FontAwesome name="linkedin-square" />
          </a>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js